import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AccountModel} from "../../../../../domain/models/account.model";
import {CustomerFormComponent} from "../components/customer-form-component";
import {MatTabsModule} from "@angular/material/tabs";
import {PropertiesTabComponent} from "../components/properties-tab/properties-tab.component";
import {AccountReceiptsTabComponent} from "../components/account-receipts-tab/account-receipts-tab.component";
import {AccountBankingTabComponent} from "../components/account-banking-tab/account-banking-tab.component";
import {AccountNotesTabComponent} from "../components/account-notes-tab/account-notes-tab.component";
import {AccountAttachmentsTabComponent} from "../components/account-attachments-tab/account-attachments-tab.component";
import {AccountHistoryTabComponent} from "../components/account-history-tab/account-history-tab.component";
import {BillingTabComponent} from "../components/billing-tab/billing-tab.component";
import {AccountBedProfileComponent} from "../../../../../common/account-bed-profile/account-bed-profile.component";
import {AccountMgmtProfileComponent} from "../../../../../common/account-mgmt-profile/account-mgmt-profile.component";
import {AccountReturnsTabComponent} from "../components/account-returns-tab/account-returns-tab.component";

@Component({
  selector: 'app-account-detail-individual-bed',
  standalone: true,
  imports: [
    MatTabsModule,
    PropertiesTabComponent,
    AccountReceiptsTabComponent,
    AccountBankingTabComponent,
    AccountNotesTabComponent,
    AccountAttachmentsTabComponent,
    AccountHistoryTabComponent,
    BillingTabComponent,
    AccountBedProfileComponent,
    AccountMgmtProfileComponent,
    AccountReturnsTabComponent
  ],
  templateUrl: './account-detail-individual-bed.component.html',
  styleUrl: './account-detail-individual-bed.component.css'
})
export class AccountDetailIndividualBedComponent implements CustomerFormComponent {
  @Input() account!: AccountModel;
  /** Set from the URL so returning to this account lands on the tab it was left on. */
  @Input() selectedIndex = 0;
  @Output() selectedTab = new EventEmitter<number>();
  @ViewChild(AccountBedProfileComponent) profile!: AccountBedProfileComponent;

  getUpdatedAccount(): AccountModel {
    return this.profile.getUpdatedAccount();
  }

  isFormValid(): boolean {
    return this.profile.isFormValid();
  }

  raiseFormValidations(): void {
    this.profile.raiseFormValidations();
  }

}
